import { useCallback, useMemo } from "react";
import {
  useSearchParams,
  SetURLSearchParams,
  createSearchParams,
  URLSearchParamsInit,
} from "react-router-dom";

export const useCustomSearchParams = (
  init?: URLSearchParamsInit
): [URLSearchParams, SetURLSearchParams] => {
  const [_, setSearchParams] = useSearchParams(init);
  const currentParams = useMemo(
    () => createSearchParams(window.location.search),
    [window.location.search]
  );

  const setSearchParamsCustom = useCallback<SetURLSearchParams>(
    (nextInit, options) => {
      const nextInitResult =
        typeof nextInit === "function" ? nextInit(currentParams) : nextInit;

      setSearchParams(nextInitResult, options);
    },
    [currentParams]
  );

  return [currentParams, setSearchParamsCustom];
};
